// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.check-label[data-v-539cadfc] {\r\n    color: grey;\n}\n.margin-vertical-15[data-v-539cadfc]{\r\n    margin-top: 15px;\r\n    margin-bottom: 15px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
